import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { checkNestedProperties } from "../../utils";
import t from "../../translate";
import { getClone } from "../../utils";
import GenerateTranslationPart from "../generate_translation_part";

const Page = (props) => {

  const onChange = (e) => {
    let newTranslation = getClone(props.activeTranslation);
    newTranslation[e.target.name] = e.target.value;
    props.setActiveTranslation(newTranslation)
  }

  const onChangeEditor = (indexKey, updatefield, content) => {
    let newTranslation = getClone(props.activeTranslation);
    newTranslation[updatefield] = content;
    props.setActiveTranslation(newTranslation)
  }

  return (
    <div className="translation-edit">
      {typeof props.activePage.settings !== 'undefined' ?
      <div className="translation_item">
        <div className="title">
          <label>{t("Titel")}</label><br />
          <div className="clearfix">
            <div className="original">
                {props.activePage.settings.title}
            </div>
            <div className="editor_holder">
            <input type="text" name={'page_title_'+props.activePage.id} onChange={(e) => onChange(e)} value={
                checkNestedProperties(props.activeTranslation, 'page_title_'+props.activePage.id) ? props.activeTranslation['page_title_'+props.activePage.id] : props.activePage.settings.title } />
            </div>
          </div>
        </div>

            {
              (typeof props.activePage.settings !== 'undefined' && typeof props.activePage.settings.parts !== 'undefined') ?

                <span>
                {
                  props.activePage.settings.parts.map((part, index) => {
                    return (
                    <GenerateTranslationPart key={index} part={part} index={index} onChange={onChange} onChangeEditor={onChangeEditor} translation={props.activeTranslation} mainId={props.activePage.id} />
                    )
                  })
                }
                </span>
              : ''
            }

            {
              (typeof props.activePage.settings !== 'undefined' && typeof props.activePage.settings.ranges !== 'undefined') ?

                <span>
                {
                  props.activePage.settings.ranges.map((part, index) => {
                    return (
                    <GenerateTranslationPart key={index} part={part} index={index+'_range'} onChange={onChange} onChangeEditor={onChangeEditor} translation={props.activeTranslation} mainId={props.activePage.id} />
                    )
                  })
                }
                </span>
              : <></>
            }
      </div>
      :false}
    </div>
  )
}

export default Page;
